export default "/images/framework/RuleEng.f0794394.svg?f0794394";